import React, { useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'

import usePageLoaded from '../../hooks/usePageLoaded'
import { useShowBackButton } from '../../hooks/useBackButton'

import Title from '../../components/ui/title/title'
import PaginationWrapper from '../../components/pagination/paginationWrapper'
import ForumLinks from '../../components/forumBlock/ForumLinks'

import { RootState } from '../../store/rootReducer'
import { fetchMemberForumPosts } from '../../store/member/memberSlice'
import { fetchProfile, fetchUserForumPosts } from '../../store/profile/profileSlice'
import { Helmet } from 'react-helmet'
import { META } from '../../constants/meta'

import { getLangFromPath } from '../../i18next'
import { checkAuth } from '../../utils/auth'
import { PaginationUserForumPostsLink } from '../../components/ui/paginationLink/PaginationLink'
import { addLocationToString } from '../../utils/meta'
import PageHeader from '../../components/profile/pageHeader'
import Button from '../../components/ui/button'

const Posts = () => {
    usePageLoaded()
    useShowBackButton()

    const [t] = useTranslation()
    const dispatch = useDispatch()
    const location = useLocation()

    const self = location.pathname.includes('/membre')

    const { user, userForumPosts, userForumPostsTotal } = useSelector((state: RootState) =>
        self ? state.member : state.profile
    )

    const getCurrentPage = () => Number(new URLSearchParams(location.search).get('p'))
    const [currentPage, setCurrentPage] = useState(getCurrentPage() || 1)

    useEffect(() => {
        setCurrentPage(getCurrentPage())
    }, [location.search])

    return (
        <div className="pageContent" style={{ margin: '0 auto', maxWidth: '1360px', padding: '90px 27px' }}>
            <Helmet>
                <title>
                    {addLocationToString(
                        META.posts[getLangFromPath(location.pathname)].title.replace('{NICK}', user.nick),
                        user
                    )}
                </title>
                <meta
                    name="description"
                    content={
                        self
                            ? META.posts[getLangFromPath(location.pathname)].description
                            : addLocationToString(
                                  META.posts[getLangFromPath(location.pathname)].description.replace(
                                      '{NICK}',
                                      user.nick
                                  ),
                                  user
                              )
                    }
                />
            </Helmet>
            <div className="pageRow" style={{ marginBottom: '20px' }}>
                <PageHeader user={user} self={self} text={'My participations in the forum'} />
            </div>

            {userForumPosts.length ? (
                <ForumLinks forumPosts={userForumPosts} withHeader userForumPostsTotal={userForumPostsTotal} />
            ) : (
                <p dangerouslySetInnerHTML={{ __html: t('I have not yet participated in the forum') }} />
            )}

            {userForumPostsTotal > 50 && (
                <PaginationWrapper
                    limit={50}
                    limitOptions={50}
                    maxButtons={5}
                    activePage={currentPage}
                    linkAs={PaginationUserForumPostsLink}
                    noPagination
                    onchange={(page: number) => {
                        setCurrentPage(page)
                        if (self) {
                            dispatch(fetchMemberForumPosts({ user_id: user.id, p: page }))
                        } else if (!self) {
                            dispatch(fetchUserForumPosts({ user_id: user.id, p: page }))
                        }
                    }}
                    total={userForumPostsTotal}
                />
            )}
        </div>
    )
}

// @ts-ignore
Posts.getInitialProps = async ({ store, location, req, match }) => {
    const self = match.path.includes('/membre')
    const page = req ? req.query.p : new URLSearchParams(location.search).get('p')

    if (self) {
        await checkAuth(store)
        const {
            member: { loggedIn, user }
        } = store.getState()

        if (loggedIn) await store.dispatch(fetchMemberForumPosts({ user_id: user.id, p: page || 1 }))
    } else {
        const {
            params: { nick }
        } = match
        await store.dispatch(fetchProfile({ nick }))
        const {
            profile: { user }
        } = store.getState()
        if (user && user.id) {
            await store.dispatch(fetchUserForumPosts({ user_id: user.id, p: page || 1 }))
        } else {
            return { statusCode: 404 }
        }
    }
}

export default Posts
